// Rotas da área Nexus IA, uma por seção (o menu tem um item para cada). Entram
// no dashboard.routes.js do core por um patch de uma linha (ver
// custom/docs/PATCHES.md). Só administrador: o menu esconde o item de quem não
// pode, porque lê estas permissões.
import { frontendURL } from 'dashboard/helper/URLHelper';
import { CONVERSATION_PERMISSIONS } from 'dashboard/constants/permissions';
import NexusPage from './NexusPage.vue';
import NexusSecao from './NexusSecao.vue';
import TeiaPage from '../teia/TeiaPage.vue';
import GestaoPage from '../gestao/GestaoPage.vue';
import GestaoPainel from '../gestao/GestaoPainel.vue';
import AplicativosPage from '../aplicativos/AplicativosPage.vue';

const meta = { permissions: ['administrator'] };
// Gestão: a Auditoria é liberada por pessoa (e Minhas avaliações, para o
// atendente); quem decide é o servidor (Neuxs::Acesso), então a rota aceita
// todos os papéis e o menu só mostra o item a quem tem o recurso.
const todos = {
  permissions: ['administrator', 'agent', ...CONVERSATION_PERMISSIONS],
};
const gestao = (caminho, name, id) => ({
  path: frontendURL(`accounts/:accountId/gestao/${caminho}`),
  name,
  meta: todos,
  component: GestaoPage,
  props: { secao: id },
});
const secao = (caminho, name, id) => ({
  path: frontendURL(`accounts/:accountId/nexus/${caminho}`),
  name,
  meta,
  component: NexusSecao,
  props: { secao: id },
});

export const routes = [
  // Endereço antigo e atalho: vai para a primeira seção liberada.
  {
    path: frontendURL('accounts/:accountId/nexus'),
    name: 'neuxs_nexus',
    meta,
    component: NexusPage,
  },
  secao('disparos', 'neuxs_nexus_disparos', 'DISPAROS'),
  secao('gateway', 'neuxs_nexus_gateway', 'GATEWAY'),
  secao('manutencao', 'neuxs_nexus_manutencao', 'MANUTENCAO'),
  secao('uso-whatsapp', 'neuxs_nexus_uso', 'USO'),
  // Monitoramento e Auditoria: uma tela só (GestaoPainel), com as abas no topo;
  // a aba da Auditoria vem no endereço, para o menu e o favorito acertarem.
  {
    path: frontendURL('accounts/:accountId/gestao/monitoramento'),
    name: 'neuxs_gestao_monitoramento',
    meta,
    component: GestaoPainel,
    props: { visao: 'MONITORAMENTO' },
  },
  {
    path: frontendURL('accounts/:accountId/gestao/auditoria/:aba?'),
    name: 'neuxs_gestao_auditoria',
    meta: todos,
    component: GestaoPainel,
    props: rota => ({
      visao: 'AUDITORIA',
      aba: rota.params.aba || 'relatorio',
    }),
  },
  { ...gestao('tv', 'neuxs_gestao_tv', 'TV'), meta },
  gestao('minhas-avaliacoes', 'neuxs_gestao_minhas', 'MINHAS'),
  // Aplicativos (Integrações → Painel de Aplicativos) em tela cheia, para
  // qualquer papel: o atendente usa o SGP o dia todo.
  {
    path: frontendURL('accounts/:accountId/aplicativos/:appId?'),
    name: 'neuxs_aplicativos',
    meta: todos,
    component: AplicativosPage,
    props: rota => ({ appId: rota.params.appId || null }),
  },
  // Nexus Neural: tela própria (escura, de vitrine), sem o molde das seções.
  {
    path: frontendURL('accounts/:accountId/nexus/neural'),
    name: 'neuxs_nexus_teia',
    meta,
    component: TeiaPage,
  },
];
